<template>
  <div>
    <div ref='recordSubscriptionForm' aria-hidden="true" class="modal fade hidden" role="dialog" tabindex='-1'>
      <div class="modal-dialog">
        <div class="modal-content">
        <form ref="recordSubscriptionEventForm"  @submit.prevent="recordSubscribe($event)">
        <div class="modal-header">
          <h5 class="modal-title mt-0">
          <span>{{ $t('folder_show.activities.subscribe_to_record') }}:</span>
          {{ record.name }}
          </h5>
        </div>
        <div class='modal-body text-left'>
          <p>{{ $t('folder_show.activities.subscribe_updates') }}:</p>
          <label class="checkbox-container">
            {{ $t('records_list.events.expiration_changed') }}
            <input type="checkbox" name="record_subscription_events[event_group][]" value="expiration_changed" :checked="check_event_group('expiration_changed')">
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('records_list.events.note_changed') }}
            <input type="checkbox" name="record_subscription_events[event_group][]" value="note_changed" :checked="check_event_group('note_changed')">
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('records_list.events.version_changed') }}
            <input type="checkbox" name="record_subscription_events[event_group][]" value="version_changed" :checked="check_event_group('version_changed')">
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.record_notify_via') }}:</p>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_email') }}
            <input type="checkbox" name="record_subscription_events[activity_notify_via][]" value="email" :checked="check_notify_via('email')">
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_app') }}
            <input type="checkbox" name="record_subscription_events[activity_notify_via][]" value="app" :checked="check_notify_via('app')">
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.frequency_days') }}:</p>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_immediately') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="0" :checked="subscription.activity_notify_days === 0 || !isSubscribed">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_weekly') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="7" :checked="subscription.activity_notify_days === 7">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.bi_weekly') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="14" :checked="subscription.activity_notify_days === 14">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.monthly') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="30" :checked="subscription.activity_notify_days === 30">
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
        </div>
        <div class="modal-footer">
          <input v-if='isSubscribed' @click.prevent='unsubscribe' type='reset' class="btn btn-outline-danger float-right" :value="$t('folder_show.activities.unsubscribe')" :disabled='disabledButton' />
          <button type='submit' class="btn btn-primary float-right" :disabled='disabledButton'>
            {{ ((isSubscribed) ? $t('folder_show.activities.update_button') : $t('folder_show.activities.subscribe')) }}
          </button>
        </div>
        </form>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        currentRecord: {},
        disabledButton: false,
      }
    },
    computed: {
      subscription() {
        return this.state.recordSubscription || {}
      },
      isSubscribed(){
        return (Object.keys(this.subscription).length > 0)
      },
      record(){
        return this.currentRecord
      },
      recordId(){
        return this.record.id || null
      },
    },
    created() {
      this.loadSubscription()
    },
    methods: {
      open(record) {
        this.currentRecord = record
        this.loadSubscription()
        $(this.$refs.recordSubscriptionForm).modal('show')
      },
      closeModal() {
        $(this.$refs.recordSubscriptionForm).modal('hide')
      },
      check_event_group(event){
        let attr = this.subscription.record_subscription_events
        return attr !== undefined ? attr.event_group.includes(event) : true
      },
      check_notify_via(event){
        let attr = this.subscription.record_subscription_events
        return attr !== undefined ? attr.activity_notify_via.includes(event) : true
      },
      loadSubscription() {
        if(Object.keys(this.record).length > 0){
          this.store.getRecordSubscription(this.record.id)
        }
      },
      recordSubscribe(e) {
        this.disabledButton = true

        const params = new FormData(e.target) 

        let subscriptionForm = this.$refs.recordSubscriptionForm
        let event_groups = subscriptionForm.querySelectorAll("input[name='record_subscription_events[event_group][]']:checked").length
        let notify_via = subscriptionForm.querySelectorAll("input[name='record_subscription_events[activity_notify_via][]']:checked").length
        let frequency = subscriptionForm.querySelectorAll("input[name='record_subscription[activity_notify_days]']:checked").length

        if(event_groups === 0){
          this.$toastr.error(this.$t('folder_show.activities.errors.select_event_group'))
          return false
        }else if(notify_via === 0){
          this.$toastr.error(this.$t('folder_show.activities.errors.select_notify_via'))
          return false
        }else if(frequency === 0){
          this.$toastr.error(this.$t('folder_show.activities.errors.select_frequency'))
          return false
        }

        this.store.createRecordSubscription(this.recordId, params).then(() => {
          this.$toastr.success(this.$t('folder_show.activities.successfully_subscribed'))
          this.$emit('reload-callback')
          this.disabledButton = false
          this.store.sendMetrics({name: 'record_subscribe', params: this.$route.params, path: this.$route.fullPath})
        }).catch(() => {
           this.disabledButton = false
        })
        this.loadSubscription()
        this.closeModal()
      },
      unsubscribe() {
        this.disabledButton = true
        this.store.deleteRecordSubscription(this.recordId, this.subscription.id).then(() => {
          this.$toastr.success(this.$t('folder_show.activities.successfully_unsubscribed'));
          this.disabledButton = false
          this.$emit('reload-callback')
          this.store.sendMetrics({name: 'remove_record_subscribe', params: this.$route.params, path: this.$route.fullPath})
        }).catch(() => {
          this.disabledButton = false
        })
        this.loadSubscription()
        this.closeModal()
      }
    }
  }
</script>
